import api from "../../client";
import { LinkSectionEnum, LinksResponseData } from "../../types/link";

export const linkListRequest = async (
  section: LinkSectionEnum,
  id: string | undefined,
) => {
  const { data } = await api.get<LinksResponseData>(`/${section}/${id}/links`);

  return data;
};

// export const jobLinkListRequest = async (id: string | undefined) => {
//   const { data } = await api.get<LinksResponseData>(`/job/${id}/links`);

//   return data;
// };

// export const educationLinkListRequest = async (id: string | undefined) => {
//   const { data } = await api.get<LinksResponseData>(`/education/${id}/links`);

//   return data;
// };
